(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/ticket-partner/assets/react/shared-components/input/phone-input.js') >= 0) return;  svs.modules.push('/modules/ticket-partner/assets/react/shared-components/input/phone-input.js');
"use strict";


const TextInput = svs.ui.reactFormInputs.TextInput;
const validateIsOnlyDigits = svs.ticket_partner.utils.validateIsOnlyDigits;
const PHONE = svs.ticket_partner.sharedComponents.input.constants.names.PHONE;
const _svs$ticket_partner$s = svs.ticket_partner.sharedComponents.input.constants.TEXTS.PHONE_NUMBER,
  LABEL = _svs$ticket_partner$s.LABEL,
  REQUIRED_ERROR = _svs$ticket_partner$s.REQUIRED_ERROR;
const PhoneNrInput = _ref => {
  let handleChange = _ref.handleChange,
    state = _ref.state,
    _ref$isLessSpace = _ref.isLessSpace,
    isLessSpace = _ref$isLessSpace === void 0 ? false : _ref$isLessSpace;
  return React.createElement(TextInput, {
    errorMessageRequired: REQUIRED_ERROR,
    id: PHONE,
    isLessSpace: isLessSpace,
    isRequired: true,
    label: LABEL,
    name: PHONE,
    onChange: handleChange,
    validateFn: validateIsOnlyDigits,
    value: state[PHONE]
  });
};
svs.ticket_partner.sharedComponents.input.PhoneNrInput = PhoneNrInput;

 })(window);